// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"433dab140b36be2a","5763":"46bfe9a41e1f31d2","6893":"e5754b7ebfca9660","6974":"804ee93f97dc1406","7222":"b869bee9af448b47","7937":"d7571b0aae774619"}[chunkId] + ".js";
};